import React from "react"
import "./App.css"
import Light from "./components/Light"
import Departures from "./components/Departures"
import Container from "react-bootstrap/Container"
import Badge from "react-bootstrap/Badge"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Power from "./components/DtuInfo"

export default function App() {
  return (
    <Container>
      <Row>&nbsp;</Row>
      <Row>
        <Col>
          <h4>
            <Badge bg="secondary">Departures</Badge>
          </h4>
          <Departures stopId="900162504" />
          <h4>
            <Badge bg="secondary">Power</Badge>
          </h4>
          <Power/>
        </Col>
        <Col>
          <h4>
            <Badge bg="secondary">Lights</Badge>
          </h4>
          <Light id="20" />
          <Light id="14" />
          <Light id="17" />
          <Light id="19" />
          <Light id="11" />
          <Light id="9" />
          <Light id="12" />
          <Light id="18" />
        </Col>
      </Row>
    </Container>
  )
}
